<style lang='postcss'>
    .boxShadow {
    transition: all 0.5s linear;
  }

  .boxShadow::after {
    content: "";
    border-radius: 5px;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    animation: changingOpacity 5s linear forwards infinite;
    --leftShadow: 5px;
    --rightShadow: -5px;
    --topShadow: 20px;
    --bottomShadow: 2.5px;
    box-shadow: var(--leftShadow) var(--bottomShadow) var(--topShadow) #ff00f2, 0px var(--bottomShadow) var(--topShadow) #99318b, var(--rightShadow) var(--bottomShadow) var(--topShadow) #af326a;
    transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  .boxShadow.connected::after {
    box-shadow: var(--leftShadow) var(--bottomShadow) var(--topShadow) #2bff47d9, 0px var(--bottomShadow) var(--topShadow) #319948, var(--rightShadow) var(--bottomShadow) var(--topShadow) #e9ff20;
  }
  .boxShadow:hover::after, :global(.promoted::after) {
    --leftShadow: 10px;
    --rightShadow: -10px;
    --topShadow: 40px;
    --bottomShadow: 5px;
    opacity: 1;
  }

  @keyframes changingOpacity {
    0% {
      opacity: 0.6;
    }
    10% {
      opacity: 1;
    }
    20% {
      opacity: 0.4;
    }
    50% {
      opacity: 0.7;
    }
    100% {
      opacity: 0.6;
    }
  }

  .boxShadow:hover::after {
    transform: scale(1.07, 1.07);
  }

  .borderBottom {
    margin-bottom: 20px; padding-bottom:20px; border-bottom: 1px solid #ec4899d9;
  }

  .borderBottom.connected {
    margin-bottom: 20px; padding-bottom:20px; border-bottom: 1px solid #2bff47d9;
  }

  .before-green::before, .before-green::after {
    background-color: #2bff47d9;
  }
</style>

<div class="mx-auto grid place-items-center mt-10 relative" style="max-width: 100rem" in:fade="{{duration: 500}}">
  <div class='flex justify-around align-middle w-full'>
    <div class='relative rounded-xl' style='width: 70%'>
      <div class='relative rounded-xl bg-black bg-opacity-20 boxShadow {$connected ? 'connected' : ""}'>
        <div class="relative px-7 py-4 rounded-lg leading-none flex items-center divide-x divide-gray-600 w-full">        
          <div class='flex w-full h-full flex-col items-center'>
            <!-- FarmBox Header -->
            <div class='w-full flex justify-center flex-wrap borderBottom {$connected ? 'connected' : ""}'>
              <h1 class='text-white text-4xl font-bold'>Distribution</h1>
            </div>
            <div class="text-white px-4 py-2 w-full">
              <table style="white-space: nowrap;">
                <tr><td><b>Total Supply:</b></td><td>100 000 000 SINU</td></tr>
                <tr><td><b>NEON-SINU Pool:</b></td><td>51 950 000 SINU distributed over 2 Months</td></tr>
                <tr><td><b>SINU Staking pool:</b></td><td>27 050 000 SINU distributed over 2 Months</td></tr>
                <tr><td><b>NEON Staking Pool:</b></td><td>7 000 000 SINU distributed over 1 Month</td></tr>
                <tr><td><b>Bonding Curve:</b></td><td>10 000 000 SINU sold at $0.001 starting price on NeonSwap</td></tr>
                <tr><td><b>Team:</b></td><td>4 000 000 unlocked SINU distributed to the team</td></tr>
                <tr><td><b>Airdrop:</b></td><td>After one week, the non sold SINU will be airdropped </td></tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="divider divider-vertical {$connected ? "before-green" : "before:bg-pink-500 after:bg-pink-500"}"></div> 
    <div class='relative rounded-xl bg-black bg-opacity-20 boxShadow {$connected ? 'connected' : ""}'>
      <div class="relative px-7 py-4 rounded-lg leading-none flex items-center divide-x divide-gray-600 w-full">        
        <div class='flex w-full h-full flex-col items-center'>
          <!-- FarmBox Header -->
          <div class='w-full flex justify-center flex-wrap borderBottom {$connected ? 'connected' : ""}'>
            <h1 class='text-white text-4xl font-bold'>Contracts</h1>
          </div>
          <div class="text-white px-4 py-2 w-full">
            <table style="white-space: nowrap;">
              <tr><td><b>SINU Token</b></td></tr>
              <tr><td><b>SINU-NEON staking pool</b></td></tr>
              <tr><td><b>NEON staking pool</b></td></tr>
              <tr><td><b>SINU staking pool</b></td></tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<script>
  import {fade, blur, fly, slide, scale, draw, crossfade} from 'svelte/transition'
  import { connected } from './../stores.js';
</script>
